import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {tagsApi} from "../../api/api";
import {Status} from "../state";
import {fetchInstruments} from "./instruments";

export const tagsSlice = createSlice({
  name: 'tags',
  initialState: {
    data: [],
    status: Status.IDLE,
    error: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
    .addCase(fetchTags.pending, (state: any) => {
      return ({
        ...state,
        status: Status.LOADING,
      })
    })
    .addCase(fetchTags.fulfilled, (state: any, {payload}) => {
      return ({
        ...state,
        data: payload,
        status: Status.SUCCEEDED,
      })
    })
    .addCase(fetchTags.rejected, (state: any) => {
      return ({
        ...state,
        error: 'Something went wrong',
        status: Status.FAILED,
      })
    })
    .addCase(updateTags.fulfilled, (state: any, {payload}) => {
      return {...state, data: payload}
    })
  },
})

export const fetchTags = createAsyncThunk('tags/fetchTags', async () => {
  return await tagsApi.getTags().then(response => response.data)
})

export const updateTags = createAsyncThunk('tags/updateTags', async (tags: any, thunkAPI) => {
  try {
    return await tagsApi.updateTags(tags).then(
        response => response.data
    )
    .then(tags => {
      thunkAPI.dispatch(fetchInstruments())
      return tags
    })
  } catch (err:any) {
    if (!err.response) {
      throw err
    }

    /*return thunkAPI.rejectWithValue({
      status: err.response.status,
      message: "Es existiert bereits ein Instrument, dass zu dieser Gruppe gehört.",
    })*/
    if (err.response.status === 201) return err.response.data;
    if (err.response.status === 400) return thunkAPI.rejectWithValue({
      status: err.response.status,
      message: "Es existiert bereits ein Instrument, dass zu dieser Gruppe gehört.",
    });
  }
})

export default tagsSlice.reducer